import * as Yup from "yup";

export const formValidator = () =>
	Yup.object({
		virtualClassCode: Yup.string().notRequired()
	});
